import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "res-tabs-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "TYPE:", -1)
const _hoisted_3 = { class: "res-tabs" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "INDICATOR:", -1)
const _hoisted_5 = { class: "res-tabs" }
const _hoisted_6 = { class: "results-shared-comp" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(['res-tab', _ctx.type === 'core' ? 'res-tab-active' : '']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.type = 'core'))
        }, "Core Indicators", 2),
        _createElementVNode("div", {
          class: _normalizeClass(['res-tab', _ctx.type === 'other' ? 'res-tab-active' : '']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.type = 'other'))
        }, "Other Indicators", 2)
      ]),
      _hoisted_4,
      _createElementVNode("span", _hoisted_5, [
        _createVNode(_component_router_link, { to: { name: 'Anthropometry'} }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(['res-tab', _ctx.indicator === 'Anthropometry' ? 'res-tab-active' : '']),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.indicator = 'Anthropometry'))
            }, "Anthropometry", 2)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: { name: 'Mortality'} }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(['res-tab', _ctx.indicator === 'Mortality' ? 'res-tab-active' : '']),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.indicator = 'Mortality'))
            }, "Mortality", 2)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_router_view)
    ])
  ], 64))
}